import { render } from "./OrganizationDetails.vue?vue&type=template&id=81b3d670&ts=true"
import script from "./OrganizationDetails.vue?vue&type=script&lang=ts"
export * from "./OrganizationDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__